"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _ui = require("@unite-us/ui");
var _ProviderCardLoading = _interopRequireDefault(require("./ProviderCardLoading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function hasMorePages(pagingObject) {
  return !!pagingObject.next_page;
}
var ProviderSelectPaginationLoader = function ProviderSelectPaginationLoader(_ref) {
  var onLoadMore = _ref.onLoadMore,
    isFetching = _ref.isFetching,
    isReferral = _ref.isReferral,
    paging = _ref.paging;
  if (isFetching) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-provider-select__load-more--fetching"
    }, /*#__PURE__*/_react["default"].createElement(_ProviderCardLoading["default"], null));
  }
  if (hasMorePages(paging) && !_lodash["default"].isEmpty(paging)) {
    var remainingProviders = paging.total_count - 50 * paging.current_page;
    var nextLoadSize = remainingProviders > 50 ? 50 : remainingProviders;
    var label = "Load ".concat(nextLoadSize, " More Results");
    label = isReferral ? 'Load More Results' : label;
    return /*#__PURE__*/_react["default"].createElement(_ui.Button, {
      className: "ui-provider-select__load-more",
      id: "load-more",
      label: label,
      primary: true,
      onClick: onLoadMore
    });
  }
  return null;
};
ProviderSelectPaginationLoader.propTypes = {
  isFetching: _propTypes["default"].bool.isRequired,
  isReferral: _propTypes["default"].bool.isRequired,
  onLoadMore: _propTypes["default"].func.isRequired,
  paging: _propTypes["default"].object.isRequired
};
ProviderSelectPaginationLoader.defaultProps = {
  isFetching: false,
  paging: {}
};
var _default = exports["default"] = ProviderSelectPaginationLoader;